<app-page-header 
    title="Languages" 
    subtitle="Create new language configs, assign editors and preview the website.">
</app-page-header>

<div class="inset" >
    <div class="right-align">
        <button mat-raised-button color="primary" (click)="openDialog()">New Translation</button>
    </div>
    <h2>Active Translations</h2>
    <table mat-table [dataSource]="languages">
        <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef> Code </th>
            <td mat-cell *matCellDef="let language"> {{language.code}} </td>
        </ng-container>
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let language"> {{language.name}} </td>
          </ng-container>
       
          <ng-container matColumnDef="nativeName">
            <th mat-header-cell *matHeaderCellDef> Native Name </th>
            <td mat-cell *matCellDef="let language"> {{language.nativeName}} 
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let language"> <button mat-raised-button  (click)="displayActions(language)">::::</button> </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columns"></tr>
           <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>


</div>
